

import { Component, Input } from '@angular/core';
import { ShowreviewComponent } from './../showreview/showreview.component';
import { RatingComponent } from './../rating/rating.component';
export interface Review {
    // id?: number;
    userName: string;
    content: string;
    Page:string;
    rating: number;
    // createdAt?: Date;
  }
@Component({
    selector: 'app-headersection',
    imports: [ShowreviewComponent,RatingComponent],
    templateUrl: './headersection.component.html',
    styleUrl: './headersection.component.css'
})

export class HeadersectionComponent {
    @Input() Review = [];
    
}
